// extracted by mini-css-extract-plugin
export var active = "_sx-1";
export var circle = "_sx-0";
export var completed = "_sx-2";
export var connector = "_sx-4";
export var connectorCompleted = "_sx-7";
export var connectorSpacer = "_sx-5";
export var iconStrokeOverride = "_sx-8";
export var labelContainer = "_sx-6";
export var pending = "_sx-3";